import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { motion } from 'motion/react';
import type { ReactNode } from 'react';

interface StyledFilterNameProps {
  $isSelected?: boolean;
  $isHighLighted?: boolean;
}

const StyledFilterName = styled(motion.button)<StyledFilterNameProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  padding: 0 12px;
  height: 40px;
  width: 100%;
  border: none;
  outline: none;
  background-color: #fbfcfc;
  text-align: left;
  font-size: 14px;
  font-weight: ${props => (props.$isHighLighted ? 600 : 400)};
  color: ${props => (props.$isHighLighted ? '#2A46FF' : '#171717')};
  cursor: pointer;

  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: #e7e9ff;
      font-weight: 600;
    `}
`;

interface IFilterNameProps {
  isSelected?: boolean;
  children: ReactNode;
  onClick: () => void;
  isHighLighted?: boolean;
}

const FilterName = ({ isSelected, children, onClick, isHighLighted }: IFilterNameProps) => {
  return (
    <StyledFilterName
      type="button"
      $isSelected={isSelected}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      $isHighLighted={isHighLighted}
    >
      {children}
    </StyledFilterName>
  );
};

export default FilterName;
